/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface DeleteAttachment$Params {
  entityId: string;
  attachmentId: string;
  entityClass: 'BulkPrintRequest' | 'FormQualityEntry' | 'FormRiskEntry' | 'FormSnapshotRequest' | 'FormCustom';
}

export function deleteAttachment(
  http: HttpClient,
  rootUrl: string,
  params: DeleteAttachment$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteAttachment.PATH, 'delete');
  if (params) {
    rb.path('entityId', params.entityId, {});
    rb.path('attachmentId', params.attachmentId, {});
    rb.path('entityClass', params.entityClass, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteAttachment.PATH = '/attachments/{entityClass}/{entityId}/{attachmentId}';
